import { CreateInvestmentManageable, InvestmentManageable } from "./types";

export const STORE_CURRENT_INVESTMENT_ACTION = "store_current_investment";
export const STORE_CURRENT_CREATED_INVESTMENT_ACTION = "store_current_created_investment";
export const STORE_INVESTMENTS_ACTION = "store_investments";
export const STORE_UPDATE_INVESTMENT_ACTION = "store_update_investment";

interface StoreCurrentInvestmentAction {
  type: typeof STORE_CURRENT_INVESTMENT_ACTION;
  payload: {
    currentInvestment: InvestmentManageable;
  };
}

interface StoreCurrentCreatedInvestmentAction {
  type: typeof STORE_CURRENT_CREATED_INVESTMENT_ACTION;
  payload: CreateInvestmentManageable;
}

interface StoreInvestmentsAction {
  type: typeof STORE_INVESTMENTS_ACTION;
  payload: {
    investments: Array<InvestmentManageable>;
  };
}

interface StoreUpdataInvestmentAction {
  type: typeof STORE_UPDATE_INVESTMENT_ACTION;
  payload: InvestmentManageable;
}

export type Action =
  | StoreCurrentInvestmentAction
  | StoreCurrentCreatedInvestmentAction
  | StoreInvestmentsAction
  | StoreUpdataInvestmentAction;
